import actions from './actions';
import reducer from './reducer';

export { actions, reducer };


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/store/index.js